export default __webpack_public_path__ + "static/media/send_mail.2fc56127.svg";